import {Button, Stack, IconButton, Box} from "@mui/material";
import {Download} from "@mui/icons-material";
import pleshDark from "../../../theme/pleshDark";
import React from "react";

const LinksQuestion = ({risposte: links}) => {

    const handleDownload = async (url, filename, fileType) => {
        try {
            // For Firebase Storage URLs or CORS-restricted files
            if (url.includes('firebasestorage.googleapis.com') || url.includes('googleapis.com')) {
                // Try to fetch with credentials for Firebase
                const response = await fetch(url, {
                    mode: 'cors',
                    credentials: 'omit'
                });
                
                if (response.ok) {
                    const blob = await response.blob();
                    const objectUrl = window.URL.createObjectURL(blob);
                    
                    const link = document.createElement('a');
                    link.href = objectUrl;
                    link.download = filename || 'download';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(objectUrl);
                } else {
                    throw new Error('Fetch failed');
                }
            } else {
                // For other URLs, try direct download
                const link = document.createElement('a');
                link.href = url;
                link.download = filename || 'download';
                link.setAttribute('download', '');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error('Errore durante il download:', error);
            // Fallback: open in new tab
            window.open(url, '_blank');
        }
    };

    return (
        <Stack mt={3} alignItems={'center'} spacing={2} px={3} pb={5} pt={2}>
            {links.map((link, i) => (
                link?.url && (
                    <Box key={i} sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button 
                            variant={'default'} 
                            href={link?.url?.includes('http') ? link.url : `https://${link.url}`}
                            target={'_blank'}
                            fullWidth
                            sx={{
                                minHeight: '60px',
                                fontWeight: 'normal',
                                borderRadius: '0px',
                                background: link?.color || pleshDark.palette.accent.secondary2,
                                lineHeight: 1,
                            }}
                        >
                            {link?.label || ''}
                        </Button>
                        {link?.type === 'file' && (
                            <IconButton
                                onClick={() => handleDownload(link.url, link.label, link.file?.type)}
                                sx={{
                                    minWidth: '60px',
                                    minHeight: '60px',
                                    borderRadius: '0px !important',
                                    color: link?.color || pleshDark.palette.accent.secondary2,
                                }}
                            >
                                <Download />
                            </IconButton>
                        )}
                    </Box>
                )
            ))}
        </Stack>
    )
}

export default LinksQuestion